export default "__VITE_PUBLIC_ASSET__b3915236__"